import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('solar-specsheet-feature')
export class SolarSpecsheetFeature extends connect(store)(LitElement) {

	static styles = css`
		.row {
			display: flex;
			padding: 8px 0 8px 0;
			justify-content: flex-start;
			border-bottom: 1px solid #c6c6c6;
		}

		.label {
			display: inline-block;
			font: var(--font-specsheet-bold);
			padding-right: var(--specsheet-feature-padding);
			white-space: nowrap;
			flex: 1;
		}

		.value {
			width: initial;
			min-width: initial;
			padding-right: 0;
			line-height: 11px;
			font: var(--font-specsheet-light);
			flex: 2;
		}


		@media print {
			:host {
				padding: var(--specsheet-print-feature-padding) 0;
			}

			.row {
				display: flex;
				padding: var(--specsheet-print-feature-padding) 0 var(--specsheet-print-feature-padding) 0;
				justify-content: flex-start;
				border-bottom: 1px solid #c6c6c6;
			}

			.label {
				flex: 1;
				font: var(--font-specsheet-print-bold);
				display: initial;
			}

			.value {
				font: var(--font-specsheet-print-light);
				flex: 2;
			}

		}
	`;
	@property({type: String})
	key = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		// TODO: refactor
		this.styleChoice = this.getAttribute('style-choice') || '';
	}


	static properties = {
		condition: {type: Function},
		styleChoice: {type: String},
	};

	render() {
		return html`
			${this.condition === undefined || this.condition.trim() !== '' ? html`
				<div class="row ${this.styleChoice}">
				<span class="label">
					<slot name="label">label of feature</slot>
				</span>
					<span class="value">
					<slot name="value">value of feature</slot>
				</span>
				</div>
			` : ''}

		`;
	}
}
